import React from "react";
import "../css/loader.css";
const Loader = () => {
  return (
    <div className="mx-6">
      <div className="loader">
        <span className="col" />
        <span className="col" />
        <span className="col" />
        <span className="col" />
        <span className="col" />
      </div>
    </div>
  );
};

export default Loader;
